import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ViewDraftEmailPopupComponent } from './view-draft-email-popup.component';
import { DraftEmailConfirmPopupComponent } from './draft-email-confirm-popup.component';
import { IgnoreErrorPopupComponent } from './ignore-error-popup.component';
import { MaterialModule } from 'src/app/shared/material/material.module';

@NgModule({
  declarations: [ViewDraftEmailPopupComponent, DraftEmailConfirmPopupComponent, IgnoreErrorPopupComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
  ],
  exports: [ViewDraftEmailPopupComponent, DraftEmailConfirmPopupComponent, IgnoreErrorPopupComponent],
})
export class ViewDraftEmailPopupModule {}
